<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-8">
        <lib-page-header page-title="BALANÇOS ANUAIS"
          page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
          image-title="assets/img/print.png">
        </lib-page-header>
      </div>
      <div class="col-md-4">
        <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </a>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="form-group col-md-10">
        <label for="mes">Selecione o relatório</label>
        <select [(ngModel)]="balanceteSelect" name="selectBalancete" style="font-weight: bold; color: #1565c0"
          class="custom-select custom-select-sm">
          <option [selected]="item.id === balanceteSelect" [value]="item.id" *ngFor="let item of listaBalancetes">
            {{item.nome}}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-3">
        <label for="ano">Exercício</label>
        <select [compareWith]="compareFn" [(ngModel)]="exercicioSelect" id="ano" class="form-control custom-select">
          <option *ngFor="let item of listaExercicios" [ngValue]="item">
            {{item.ano}}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12">
        <label for="orgaos">Órgãos</label>
        <p-listbox id="orgaos" [options]="listaOrgaos" [(ngModel)]="orgaos" checkbox="true" multiple="true"
          [filter]="false" [showToggleAll]="false" defaultLabel="Selecione o(s) órgão(s)" styleClass="listbox-eddy">
        </p-listbox>
      </div>
    </div>
    <div class="row mt-3">
      <div class="form-group col-md-3">
        <a (click)="imprimir()" class="btn btn-sm btn-outline-secondary">
          <img src="assets/img/global/file_pdf.png" alt="cvs" title="Gerar pdf" height="20" width="20">
          Gerar PDF
        </a>
      </div>
    </div>

  </div>
</div>
